export const FETCH_BARCODES_RESOLVED = "FETCH_BARCODES_RESOLVED";
export const UPDATE_BARCODE_RESOLVED = "UPDATE_BARCODE_RESOLVED";
export const DELETE_BARCODE_RESOLVED = "DELETE_BARCODE_RESOLVED";
